import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../hisphere-logo.png';

const Header = () => {
  return (
    <header className='bg-gradient-to-br from-blue-500 to-indigo-800 dark:from-gray-800 dark:to-gray-900 text-white py-6 sticky top-0 z-10 shadow-lg'>
        <div className='container mx-auto px-8 max-w-7xl flex items-center justify-between'>
          <Link to='/' className='flex items-center gap-4 cursor-pointer'>
            <img
              src={logo}
              alt='HiSphere'
              className='w-20 h-20 logo-spin rounded-full object-cover'
            />
            <h1 className='text-3xl font-montserrat font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-cyan-300'>
              HiSphere
            </h1>
          </Link>
          <nav className='hidden md:flex gap-6'>
            <Link to='/solutions' className='hover:text-cyan-300 transition-colors duration-200'>Решения</Link>
            <Link to='/contact' className='hover:text-cyan-300 transition-colors duration-200'>Контакты</Link>
            <Link to='/about' className='hover:text-cyan-300 transition-colors duration-200'>О нас</Link>
          </nav>
        </div>
      </header>
  );
};

export default Header;
